// removed by extract-text-webpack-plugin
module.exports = {"main":"_3j6cagtaUscs1mCUugHlng"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.scss
// module id = 921
// module chunks = 0